import React from "react";
import Attendances from "./Attendances"; // Import the Attendance component

function App() {
  return (
    <div className="App">
      <Attendances /> {/* Use the Attendance component here */}
    </div>
  );
}

export default App;
